import throttle from 'lodash/throttle';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { loadState, saveState } from './localStorage';
import reducers from './reducers';

const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const persistedState = loadState();

// eslint-disable-next-line import/prefer-default-export
export const store = createStore(
  reducers,
  persistedState,
  composeEnhancers(applyMiddleware(thunk))
);

store.subscribe(
  throttle(() => {
    saveState({
      appInfo: store.getState().appInfo,
      designations: store.getState().designations
    });
  }, 1000)
);
